<template>
    <div class="userPortal"  >
      <div class="left-menu">
            <div class="work-plant" @click="jumpGateWay">
              <span>
                  <el-tooltip content="工作台" placement="left" effect="light">
                    <i class="iconfont icon-other-gongzuotai1" style="font-size: 30px;font-weight: 600; color:#1296db;cursor: pointer;margin-top: 18px;margin-left: 10px;" @click="handleConsole()"></i>
                  </el-tooltip>
                  <div class="work-plant-application-top" :style="'left:'+positionLeft+';'">
                        <template v-if="portalMode===0">
                          <div class="work-plant-application">
                              <div class="commonly-app">
                                  <div><el-tag>已选工作台菜单</el-tag></div>
                                  <div style="margin-left:10px" ><i class="el-icon-setting" title='配置工作台' style="cursor: pointer" @click.stop="setCommonly"></i></div>
                              </div>
                              <draggable :list="menuDataSource" :options="appContentOpts" class="subform-field-list" @change="handleMenuChange(0)">
                                  <div class="application-item" v-for="(item,index) in menuDataSource" :key="index" @click.stop="navWorkMenu(item)">
                                      <div class="icon"><i :class="item.meta.icon" :style="'color:'+item.meta.color+';'"></i></div>
                                      <div class="title">{{item.meta.title}}</div>
                                      <div class="opera" v-if="isEdit&&item.isEntry==true"><i class="iconfont icon-other-jian-tianchong" @click.stop="updateWorkPlantEntry(item,1,0);"></i></div>
                                  </div>
                              </draggable>
                          </div>
                          <div class="work-plant-application-all"  v-if="isEdit">
                              <div class="commonly-app">
                                  <div><el-tag type="success">待选工作台菜单</el-tag></div>
                              </div>
                              <div :style="portalMode===0?'width:140px':''" class="application-item" v-for="(item,index) in allMenu" :key="index" v-if="item.isEntry">
                                  <div class="icon"><i :class="item.meta.icon" :style="'color:'+item.meta.color+';'"></i></div>
                                  <div class="title">{{item.meta.title}}</div>
                                  <div class="opera"><i class="iconfont icon-other-tianjia" @click.stop="updateWorkPlantEntry(item,2,0);"></i></div>
                              </div>
                          </div>
                        </template>
                  </div>
              </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { cloneDeep } from 'lodash';
    import mixinsNav from '@/mixins/mixins-nav';
    import { getCurrentUserInfo, updateWorkPlantEntry, dragWorkPlantEntry, getUserWorkPlantEntry, getPublishedApplicationList, changePortalMode, getModelListByType } from '@/data-model';
    import * as constants from '@/common/constants';
    import Draggable from 'vuedraggable';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Draggable
        },
        filters: {
            ellipsis: function (value) {
                if (!value) return '';
                if (value.length > 10) {
                    return value.slice(0, 10) + '...';
                }
                return value;
            }
        },
        data () {
            return {
                isShowUpgradeBtn: false,
                menuDataSource: [],
                isEdit: false,
                isEditApp: false,
                isEditDashboard: false,
                allMenu: [],
                positionLeft: this.isNotConsole ? '10px' : '220px',
                appContentOpts: {
                    // handle: '.form-item-label',
                    group: {
                        name: 'appContent',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                },
                appContentOpts2: {
                    // handle: '.form-item-label',
                    group: {
                        name: 'appContent',
                        put: [ 'formToolbar' ]
                    },
                    sort: true
                },
                portalMode: null, // 首页模式 0：工作台 1：应用系统  2：仪表盘
                // applicationList: [], // 应用系统列表
                selectedAppId: '', // 当前选中系统
                selectedId: '', // 系统对应主键
                selectedAppName: '', // 当前选中系统
                allDashboard: [],
                dashboardSource: [],
                currentUserInfo: {}
            };
        },
        props: {
            appState: {
                type: Object
            },
            menuData: {
                type: Array
            },
            applicationList: {
                type: Array
            },
            isNotConsole: {
                type: Boolean,
                default: false
            },
            defaultAppId: {
                type: Number
            },
            defaultAppName: {
                type: String
            }
        },
        watch: {
            workPlantEntry (newVal, oldVal) {
                if (newVal) {
                    this.menuDataSource = cloneDeep(newVal);
                    this.initAllMenu();
                }
                return newVal;
            },
            sidebarOpened (newVal, oldVal) {
                if (newVal) {
                    this.positionLeft = '220px';
                } else {
                    this.positionLeft = '60px';
                }
            },
            applicationList (newVal, oldVal) {
                if (newVal) {
                    if (newVal && this.defaultAppId) {
                        newVal.forEach(app => {
                            if (app.id === this.defaultAppId) {
                                this.selectedAppName = app.label;
                            }
                        });
                    }
                }
            },
            defaultAppId (newVal, oldVal) {
                if (newVal) {
                    if (newVal && this.applicationList) {
                        this.applicationList.forEach(app => {
                            if (app.id === newVal) {
                                this.selectedAppName = app.label;
                            }
                        });
                    }
                }
            }
        },
        computed: {
            sidebarOpened () {
                return this.appState.sidebar.opened;
            },
            ...mapGetters([
                'workPlantEntry',
                'userInfo'
            ])
        },
        created () {
            this.initUser();
            // this.initAllDashbord();
            // this.initApplicationList();
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_WORK_PLANT_ENTRY,
                constants.VUEX_ACTIONS_USER_INFO
            ]),
            handleConsole () {
                if (this.isNotConsole && this.portalMode !== 0) {
                    let modeName = this.portalMode === 1 ? '应用系统' : '仪表盘';
                    this.$confirm(`当前首页模式为【${modeName}】,您确定要切换到工作台模式吗？`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async (res) => {
                        this.changePortalMode(0);
                        this.navWorkMenu(this.workPlantEntry[0]);
                    }).catch(() => {});
                } else if (this.portalMode === 0) {
                    this.$emit('handleNavPage');
                }
            },
            navWorkMenu (obj) {
                if (this.isNotConsole) {
                    var url = obj.id;
                    if (window.location.href.indexOf('#/') !== -1) {
                        let routeData = this.$router.resolve({
                            path: url,
                            query: {
                            // name: ''
                            }
                        });
                        url = routeData.href;
                    }
                    window.open(url, '_blank');
                } else {
                    this.$emit('navWorkMenu', obj);
                }
            },
            setCommonly () {
                this.isEdit = true;
            },
            setCommonlyApp () {
                this.isEditApp = true;
            },
            setCommonlyDashboard () {
                this.isEditDashboard = true;
            },
            async initUser () {
                if (this.userInfo) {
                    this.currentUserInfo = cloneDeep(this.userInfo);
                } else {
                    this.currentUserInfo = await getCurrentUserInfo();
                }
                this.portalMode = this.currentUserInfo.portalMode ? this.currentUserInfo.portalMode : 0;// 默认工作台模式
                this.portalMode = 0;// 默认为工作台模式
                this.menuDataSource = cloneDeep(this.workPlantEntry);
                this.initAllMenu();
                if (this.portalMode > 0) {
                    this.getUserWorkPlantEntry(this.portalMode);
                }
            },
            // type:1 删除  2新增
            // mode:0 工作台  mode:1 应用系统  mode:2 仪表盘
            async updateWorkPlantEntry (obj, type, mode) {
                let param;
                if (mode === 0) {
                    param = {menuUrl: obj.path, menuId: obj.id, type: type, id: obj.dataId, portalMode: mode};
                } else if (mode === 2) {
                    param = {menuUrl: obj.modelName, menuId: type === 2 ? obj.id : null, id: obj.pkId, portalMode: mode};
                }
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                await updateWorkPlantEntry(param);
                this.getUserWorkPlantEntry(mode);
                loading.close();
            },
            async initWorkPlantEntry () {
                let workPlantEntry = await getUserWorkPlantEntry({mode: 0});
                if (workPlantEntry && workPlantEntry.data) {
                    if (window.location.href.indexOf('application/model-config') !== -1) { // 在表单列表点击【配置应用】时默认切换为工作台模式
                        await changePortalMode({userId: this.currentUserInfo.userId, portalMode: 0});
                        this.portalMode = 0;
                        return;
                    }
                    if (this.portalMode === 1) { // 选择应用系统
                        let chooseApp = workPlantEntry.data;
                        if (chooseApp && chooseApp.length > 0) {
                            this.selectedId = chooseApp[0].id;
                            this.selectedAppId = Number(chooseApp[0].menuId);
                            this.$emit('handleNavApplicaion', {id: this.selectedAppId});
                        }
                    } else if (this.portalMode === 2) { // 选择仪表盘
                        if (!this.isNotConsole) {
                            this.$emit('handleDashBoradCenter', {});
                        } else {
                            this.getUserWorkPlantEntry(2);
                        }
                    }
                }
            },
            handleNavApplicaion () {
                localStorage.setItem('defaultAppId', this.selectedAppId);
                var url = '/businessSystem';
                if (window.location.href.indexOf('#/') > -1) {
                    url = '#' + url;
                } else {
                    url = '/bpm' + url;
                }
                window.location.href = url;
            },
            async initApplicationList () {
                let apps = await getPublishedApplicationList();
                this.applicationList = apps;
            },
            async getUserWorkPlantEntry (mode) {
                let workPlantEntrys = [];
                let workPlantEntry = await getUserWorkPlantEntry({mode: mode});
                if (mode === 1) { // 选择应用系统
                    let chooseApp = workPlantEntry.data;
                    if (chooseApp && chooseApp.length > 0) {
                        this.selectedId = chooseApp[0].id;
                        this.applicationList.forEach(app => {
                            if (app.id + '' === this.selectedId) {
                                this.selectedAppName = app.label;
                            }
                        });
                    }
                } else if (mode === 2) { // 仪表盘
                    await this.initAllDashbord(workPlantEntry);
                } else if (mode === 0) { // 工作台
                    let chooseMenu = workPlantEntry.data;
                    let str = sessionStorage.getItem('noLeftMenu');
                    let o = JSON.parse(str);
                    let isContainNeedWorkingTask = false;
                    for (let i = 0; i < chooseMenu.length; i++) {
                        let obj = chooseMenu[i];
                        let menu = o.routeWorkbench.find(y => y.id === obj.menuId);
                        if (menu) {
                            menu.dataId = obj.id;
                            menu.isShow = true;
                            workPlantEntrys.push(menu);
                        }
                        if (obj.menuId === 'workspace/needWorkingTask') {
                            isContainNeedWorkingTask = true;
                        }
                    }
                    if (!isContainNeedWorkingTask) {
                        let arr = constants.VUEX_WORK_PLANT_ENTRY;
                        for (let i = 0; i < arr.length; i++) {
                            arr[i].isShow = true;
                            workPlantEntrys.unshift(arr[i]);
                        }
                    }
                    this[constants.VUEX_ACTIONS_WORK_PLANT_ENTRY](workPlantEntrys);
                    this.$emit('handleMenuChange');
                }
            },
            initAllMenu () {
                let str = sessionStorage.getItem('noLeftMenu');
                let obj = JSON.parse(str);
                let workBench = obj.routeWorkbench;
                let mAll = [];
                for (let j = 0; j < this.menuDataSource.length; j++) {
                    let m = this.menuDataSource[j];
                    mAll.push(m.id);
                }
                let source = mAll.join(',');
                let wb = [];
                for (let i = 0; i < workBench.length; i++) {
                    let o = workBench[i];
                    if (source.indexOf(o.id) === -1) {
                        wb.push(o);
                    }
                }
                this.allMenu = wb;
            },
            async initAllDashbord (workPlantEntry) {
                let param = {modelType: 5, userId: this.currentUserInfo.userId, currentPage: 1, pageSize: 1000};
                let res = await getModelListByType(param);
                let allData = [];
                if (res && res.state === 'success') {
                    allData = res.data;
                }
                if (workPlantEntry && workPlantEntry.data && workPlantEntry.data.length > 0) {
                    this.dashboardSource = workPlantEntry.data;
                    let filterAll = [];
                    let selectedDashboard = new Map();
                    for (let i = 0; i < this.dashboardSource.length; i++) {
                        let o = this.dashboardSource[i];
                        o.pkId = o.id;
                        o.isEntry = true;
                        selectedDashboard.set(o.menuId, o);
                    }
                    for (let j = 0; j < allData.length; j++) {
                        let m = allData[j];
                        if (!selectedDashboard.has(m.id)) {
                            filterAll.push(m);
                        } else {
                            selectedDashboard.get(m.id).modelName = m.modelName;
                        }
                    }
                    this.allDashboard = filterAll;
                } else {
                    this.allDashboard = allData;
                }
            },
            async handleMenuChange (portalMode) {
                let sources = [];
                if (portalMode === 0) {
                    sources = cloneDeep(this.menuDataSource);
                    sources.forEach(item => {
                        let temp = cloneDeep(item);
                        item.menuUrl = temp.path;
                        item.menuId = temp.id;
                        item.portalMode = portalMode;
                        item.id = temp.dataId;
                    });
                    await dragWorkPlantEntry(sources);
                    await this.getUserWorkPlantEntry(portalMode);
                    if (!this.isNotConsole) {
                        this.$emit('handleMenuChange');
                    }
                } else if (portalMode === 2) {
                    let sources = cloneDeep(this.dashboardSource);
                    sources.forEach(item => {
                        let temp = cloneDeep(item);
                        item.portalMode = portalMode;
                        item.id = temp.pkId;
                    });
                    await dragWorkPlantEntry(sources);
                    await this.getUserWorkPlantEntry(portalMode);
                }
            },
            navDashboard (obj) {
                sessionStorage.setItem('boardCenterSelectName', JSON.stringify(obj));
                if (!this.isNotConsole) {
                    this.$emit('handleDashBoradCenter', {});
                } else {
                    this.handleDashBoradCenter(obj);
                }
            },
            handleDashBoradCenter (obj) {
                var url = '/dashBoradCenter';
                if (window.location.href.indexOf('#/') > -1) {
                    // 本地访问路径
                    url = '#' + url;
                } else {
                    url = '/bpm' + url;
                }
                window.location.href = url;
            },
            async changePortalMode (val) {
                this.isEdit = false;
                this.isEditApp = false;
                this.isEditDashboard = false;
                await changePortalMode({userId: this.currentUserInfo.userId, portalMode: val});
                this.portalMode = val;
                this.currentUserInfo.portalMode = val;
                this[constants.VUEX_ACTIONS_USER_INFO](this.currentUserInfo);
                if (val === 0) { // 工作台
                    await this.getUserWorkPlantEntry(val);
                    if (this.isNotConsole) {
                    } else {
                        this.$emit('handleConsole');
                    }
                } else if (val === 1) { // 应用系统
                    if (!this.selectedAppId && this.applicationList && this.applicationList.length > 0) {
                        this.selectedAppId = this.applicationList[0].id;
                        this.selectedAppName = this.applicationList[0].label;
                    }
                    this.updateApp(this.selectedAppId);
                } else if (val === 2) { // 仪表盘
                    await this.getUserWorkPlantEntry(val);
                }
            },
            async handleChangeApp (item) {
                this.selectedAppId = item.id;
                this.updateApp(item.id);
            },
            async updateApp (menuId) {
                let param = {menuId: menuId, id: this.selectedId, portalMode: 1};
                await updateWorkPlantEntry(param);
                await this.getUserWorkPlantEntry(1);
                this.applicationList.forEach(app => {
                    if (app.id === menuId) {
                        this.selectedAppName = app.label;
                    }
                });
            },
            jumpGateWay () {
                let menuData = window.localStorage.getItem('defaultIndexPage');
                if (menuData) {
                    let obj = JSON.parse(menuData);
                    let url = '/' + obj.id;
                    let name = obj.name;
                    let param = {appId: obj.defaultAppId};
                    if (obj.defaultAppId) {
                        window.localStorage.setItem('defaultAppId', obj.defaultAppId);
                    }
                    if (obj.boardCenterSelectName) {
                        window.sessionStorage.setItem('boardCenterSelectName', obj.boardCenterSelectName);
                    }
                    window.sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                    window.localStorage.setItem('isNewPageInitLoad' + this.userInfo.userId, '1');
                    this.navigateNameTo(url, name, param);
                } else {
                    let catchUrl = '/workspace/gateWay';
                    this.navigateNameTo(catchUrl, 'gateWay');
                }
            }
        }
    };
</script>

<style lang="less">
    .userPortal {
        height: 57px;
        line-height: 50px;
        border-radius: 0px !important;
        // background: #fff;
        background: #ecf5ff;
        // border-bottom: 1px solid #d8dce5;
        // box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
        display: flex;
        justify-content:space-between;
        align-items: center;
        .left-menu {
            display: flex;
            align-items: center;
            .work-plant{
                .work-plant-application-top{
                    display: none;
                    height: auto;
                    background: #f2f6fc;
                    border: 1px solid #ccc;
                    z-index: 333;
                    // top:55px;
                    left: 60px;
                    position: absolute;
                    height: auto;
                    min-height: 150px;
                    .commonly-app{
                        height: 38px;
                        line-height: 38px;
                        width: 550px;
                        display: flex;
                        padding-left: 10px;
                        border-bottom: 1px solid #e3e6e6;
                    }
                    .work-plant-application{
                       align-content: flex-start;
                       width: auto;
                       width: 550px;
                       display: flex;
                       flex-wrap: wrap;
                       padding-bottom: 10px;

                       .subform-field-list{
                         display: flex;
                         flex-wrap: wrap;
                       }

                       .application-item{
                          //  width: 225px;
                           display: flex;
                           margin-left: 20px;
                           cursor: pointer;
                           .icon{
                              font-size: 20px;
                              margin-top: -2px;
                           }
                           .title{
                              font-size: 18px;
                              // width: 220px;
                           }
                           .opera{
                               .iconfont{
                                   font-size: 16px;
                                   margin-left: 10px;
                                   color: #fc0034;
                               }
                           }
                       }
                       .application-item:hover{
                           .icon{

                           }
                           .title{
                               color: #409EFF;
                           }
                       }
                    }
                    .work-plant-application-all{
                        align-content: flex-start;
                        width: auto;
                        width: 550px;
                        height: auto;
                        min-height: 150px;
                        z-index: 333;
                        display: flex;
                        flex-wrap: wrap;
                        padding-bottom: 10px;
                        .application-item{
                            width: 230px;
                            display: flex;
                            margin-left: 20px;
                            cursor: pointer;
                            .icon{
                               font-size: 20px;
                               margin-top: -2px;
                            }
                            .title{
                               font-size: 18px;
                               width: 220px;
                            }
                            .opera{
                                .iconfont{
                                    font-size: 16px;
                                    margin-left: 10px;
                                    color: #fc0034;
                                }
                            }
                        }
                    }
                }
            }
            .work-plant:hover{
                .work-plant-application-top{
                    display: block;
                }
            }
        }

        .el-dropdown-link {
          cursor: pointer;
          color: #409EFF;
        }
        .el-icon-arrow-down {
          font-size: 12px;
        }
        .demonstration {
          display: block;
          color: #8492a6;
          font-size: 14px;
          margin-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPortal/UserPortal.vue